<template>
  <div>
    <transition v-if="!state" name="fade" mode="out-in">
      <slot></slot>
    </transition>
    <transition v-else name="fade" mode="out-in">
      <div class="text-center">
        <img class="mb-5" src="@/assets/images/hprofits/unusual-event.svg" />
        <h1 class="mb-1 font-weight-normal">Welcome back!</h1>
        <p class="small mb-4 text-light">Ad Pop. Pop Ad?</p>
        <vue-recaptcha sitekey="12123423" class="d-inline-block" />
      </div>
    </transition>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  head() {
    return {
      script: [
        {
          src:
            'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit',
          defer: true,
          body: true
        }
      ]
    };
  },

  props: {
    state: {
      type: Boolean,
      default: false
    }
  },

  components: {
    VueRecaptcha
  }
};
</script>
